import { Select, theme, Tooltip } from "antd";
import React from "react";
import ColorButton from "../../common/ColorButton";
import {
  PrinterOutlined,
  FileDoneOutlined,
  EditOutlined,
  PlusOutlined,
  CheckCircleFilled,
  MinusCircleFilled,
  FileSyncOutlined
} from '@ant-design/icons';
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import { ORANGE_COLOR, PRINT_COLOR } from "../../constants/color";
import { DELETE } from "../../frameworks/HttpClient";
import { dateToHumanString, formatComma } from "../../frameworks/Util";
import TSTable from "../../common/TSTable";
import { PRODUCT_TYPE } from "../../constants/string";
import { URL_SALE } from "../../constants/urls";
import _ from "lodash";
import ErrorMessages from "../../common/ErrorMessages";
import ProducePreorderModal from "./ProducePreorderModal";
import ProduceRefSaleOrderModal from "./ProduceRefSaleOrderModal";

export default function ProducePreorderList(props) {
  const { type } = props;
  const tableRef = React.useRef();
  const { token : { colorWarning, colorSuccess, }} = theme.useToken();
  const [orderTarget, setOrderTarget] = React.useState(null);
  const [saleOrderActionTarget, setSaleOrderActionTarget] = React.useState(null);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [filterHasSaleOrder, setFilterHasSaleOrder] = React.useState(false);
  const [tableKey, setTableKey] = React.useState(0);

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleDelete = async (id) => {
    setErrorMessages(null);
    try {
      if(type === PRODUCT_TYPE.CONCENTRATE_LATEX)
        await DELETE(`${URL_SALE.PRODUCE_ORDER}${id}/`)
      if(type === PRODUCT_TYPE.SKIM)
        await DELETE(`${URL_SALE.SKIM_PRODUCE_ORDER}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  };


  const columns = [
    {
      title : 'Action',
      dataIndex : '',
      key : 'action',
      width : 160,
      render: (value, original) => (
        <div style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>

          {/* <Tooltip triger='hover' title={"รายการแจ้งผลิต"}>
            <ColorButton 
              override={PRINT_COLOR}
              style={{ margin : 5}}
              type='primary'
              icon={<PrinterOutlined />}
              onClick={() => {}} 
            />
          </Tooltip> */}

          <CustomDeleteConfirmButton
            title={`ลบใบแจ้งผลิต - ${original.lot_no}`}
            content={"คุณต้องการลบใบแจ้งผลิตใช่หรือไม่"}
            onOk={ async() => {
              await handleDelete(original.id)
              refreshData();
            }}
            onConfirm={() => refreshData()}
          />

          <Tooltip triger='hover' title={"แก้ไขข้อมูล"}>
            <ColorButton 
              override={colorWarning}
              style={{ margin : 5}}
              type='primary'
              icon={<EditOutlined />}
              onClick={() =>  setOrderTarget(original)} 
            />
          </Tooltip>

          <Tooltip triger='hover' title={original.sale_order ? "เปลี่ยนรายการขาย" : "ผูกรายการขาย"}>
            <ColorButton 
              override={original.sale_order ? ORANGE_COLOR : colorSuccess}
              style={{ margin : 5}}
              type='primary'
              icon={original.sale_order ? <FileSyncOutlined /> : <FileDoneOutlined />}
              onClick={() =>  setSaleOrderActionTarget(original)} 
            />
          </Tooltip>  

        </div>
      )
    },
    {
      title : 'วันที่แจ้งผลิต',
      dataIndex : 'due_date',
      key : 'due_date',
      render : (value) => dateToHumanString(value)
    },
    {
      title : 'Lot No',
      dataIndex : 'lot_no',
      key : 'lot_no',
      searcher : true,
    },
    {
      title : 'สินค้าที่ต้องการ',
      dataIndex : 'product_name',
      key : 'product_name'
    },
    {
      title : 'ปริมาณผลิต(Kg)',
      dataIndex : 'require_weight',
      key : 'require_weight',
      render : (value) => <div style={{textAlign: 'right'}}>{value ? formatComma(value) : '0'}</div>
    },
    {
      title : 'ปริมาณผลิต(ก้อน)',
      dataIndex : 'require_amount',
      key : 'require_amount',
      render : (value) => <div style={{textAlign: 'right'}}>{value ? formatComma(value) : '0'}</div>,
      hidden : type === PRODUCT_TYPE.CONCENTRATE_LATEX,
      // render : (value) => <center>{value ? formatComma(value) : 0}</center>
    },
    {
      title : 'ผู้แจ้งผลิต',
      dataIndex : 'created_by_name',
      key : 'created_by_name'
    },
    {
      title : 'สถานะ',
      dataIndex : 'is_produced',
      key : 'is_produced',
      render : (value) => value ? 'ผลิตแล้ว' : 'รอผลิต'
    },
    {
      title : 'รายการขาย',
      dataIndex : 'sale_order',
      key : 'sale_order',
      render:(value) => 
        <center> 
          {value ? 
            <Tooltip title={'ผูกกับรายการขายแล้ว'}>
              <CheckCircleFilled style={{color : colorSuccess, fontSize : 16}}/> 
            </Tooltip>
          : 
            <Tooltip title={'ยังไม่ได้ผูกกับรายการขาย'}>
              <MinusCircleFilled style={{color : colorWarning, fontSize : 16}}/>
            </Tooltip>
          }
        </center> 
    },
  ];

  const onChangeFilter = (value) => {
    setFilterHasSaleOrder(value)
  };

  const ResetFilter = () => {
    setTableKey(tableKey => tableKey + 1)
  }

  React.useEffect(() => {
    ResetFilter();
  },[filterHasSaleOrder])

  return(
    <div>
      <ErrorMessages message={errorMessages} style ={{ marginTop : 16}}/>
        ข้อมูลใบแจ้งผลิต : 
      <Select
        allowClear
        style={{width : 250, marginLeft : 10}}
        placeholder="สถานะการใช้งาน"
        value={filterHasSaleOrder}
        autoComplete="off"
        options={[
          {
            label : "ทั้งหมด",
            value : null
          },
          {
            label : "ไม่มีรายการขาย",
            value : false
          },
          {
            label : "มีรายการขายแล้ว",
            value : true
          },
        ]}
        onChange={onChangeFilter}
      />
      <ColorButton 
          type='primary'
          override={colorSuccess}
          icon={<PlusOutlined style={{ fontSize : 14 }}/>}
          onClick={()=> setOrderTarget('add')} 
          style={{ float : 'right', marginBottom : 10}}
      >
        {type === PRODUCT_TYPE.CONCENTRATE_LATEX ? "เพิ่มใบแจ้งผลิตน้ำยางข้น" : "เพิ่มใบแจ้งผลิตสกิม"}
      </ColorButton>

      <TSTable
        key={tableKey}
        ref={tableRef}
        columns={columns}
        url={type === PRODUCT_TYPE.CONCENTRATE_LATEX ? URL_SALE.PRODUCE_ORDER : URL_SALE.SKIM_PRODUCE_ORDER}
        params={{ has_sale_order: filterHasSaleOrder }}
        size={"small"}
      />

      <ProducePreorderModal
        open={orderTarget ? true : false}
        onClose={() => {
          setOrderTarget(null)
        }}
        onUpdate={() => {
          setOrderTarget(null)
          refreshData();
        }}
        target={orderTarget}
        type={type}
      />

      <ProduceRefSaleOrderModal
        open={saleOrderActionTarget ? true : false}
        onClose={() => {
          setSaleOrderActionTarget(null)
        }}
        onUpdate={() => {
          setSaleOrderActionTarget(null)
          refreshData();
        }}
        target={saleOrderActionTarget}
        type={type}
      />
    </div>
  )
}